export const currentAddressrequest = async (lat, lng) => {
  try {
    const calladdress = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyC1C1ymKWNgzK1uhgfxt7LVqQXf6lanYH4`,
      {
        method: "GET",
      }
    );

    return calladdress;
  } catch (error) {}
};
